export const isBrowser = () => typeof window !== `undefined` && window;

export function isGoogleBot() {
  if (isBrowser()) {
    return /googlebot|bot|crawler|spider|crawling/i.test(
      window.navigator.userAgent
    );
  }
}
